module.exports = __webpack_public_path__ + "assets/cameraConfirm@3x.407898a486194cee54143645469e0fcd.png";